import React from "react";
import { compose } from "redux";
import { List } from "immutable";
import { connect } from "react-redux";
import AddCircle from "@material-ui/icons/AddCircle";
import { Chip, Grid, MenuItem, withStyles } from "@material-ui/core";

import { ReceivedDataState } from "altus-datastate";

import DropdownMenu from "app/components/DropdownMenu";
import { EMPTY_SET, APP_ACTIONS } from "app/app.constants";
import { getActionDataStateFromState } from "app/app.selectors";

const APP_ROLE_PREFIX = "HR Planner";

const getAppRoleName = appRole =>
  appRole
    .get("name")
    .replace(APP_ROLE_PREFIX, "")
    .trim();

const AppRolesSelectField = ({
  value,
  appRoles,
  onChange,
  classes,
  dataState,
}) => {
  const roles = List(value)
    .map(uniqueInternalName => appRoles.get(uniqueInternalName))
    .filter(Boolean);

  return (
    <Grid container spacing={1} wrap="nowrap" alignItems="center">
      {appRoles.size !== roles.size && (
        <Grid item>
          <DropdownMenu Trigger={<AddCircle className={classes.addIcon} />}>
            {appRoles
              .filterNot(appRole =>
                value.contains(appRole.get("uniqueInternalName")),
              )
              .toList()
              .map(appRole => (
                <MenuItem
                  onClick={() =>
                    onChange(value.add(appRole.get("uniqueInternalName")))
                  }
                  key={appRole.get("appRoleId")}
                >
                  {getAppRoleName(appRole)}
                </MenuItem>
              ))}
          </DropdownMenu>
        </Grid>
      )}
      {!!value.size &&
        roles
          .sortBy(appRole => appRole.get("uniqueInternalName"))
          .map(appRole => (
            <Grid item key={appRole.get("appRoleId")}>
              <Chip
                onDelete={() =>
                  onChange(value.delete(appRole.get("uniqueInternalName")))
                }
                label={getAppRoleName(appRole)}
              />
            </Grid>
          ))}
    </Grid>
  );
};

AppRolesSelectField.defaultProps = {
  appRoles: EMPTY_SET,
  dataState: ReceivedDataState,
};

const styles = theme => ({
  menuItemRoot: {
    "&.Mui-selected": {
      backgroundColor: "initial",
    },
  },
  addIcon: {
    cursor: "pointer",
    fill: theme.palette.primary.light,
    color: theme.palette.getContrastText(theme.palette.primary.light),
    "&:hover": {
      fill: theme.palette.primary.main,
    },
    "&:active": {
      fill: theme.palette.primary.main,
    },
    "&:focus": {
      fill: theme.palette.primary.main,
    },
  },
  chipLabel: {
    paddingLeft: theme.spacing(0.25),
    paddingRight: theme.spacing(0.25),
  },
});

export default compose(
  connect((state, { userId }) => ({
    dataState: getActionDataStateFromState(state, {
      type: APP_ACTIONS.CREATE_USER_APP_ROLES,
      id: userId,
    }),
  })),
  withStyles(styles),
)(AppRolesSelectField);
